import { forwardRef, useState, useEffect, useContext, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { CircleMarker } from 'leaflet';

import { noop } from 'utils';

import { MapContext } from './map-container';
import { MAP_CIRCLE_MARKER_DEFAULT_OPTIONS } from './options';

export const MapCircleMarker = forwardRef(
	({ latLng = null, options, onInitialized = noop }, ref) => {
		const [circleMarker, setCircleMarker] = useState(null);
		const map = useContext(MapContext);

		useImperativeHandle(ref, () => circleMarker, [circleMarker]);

		useEffect(() => {
			if (map === null) {
				return;
			}

			const circleMarker = new CircleMarker(latLng, {
				...MAP_CIRCLE_MARKER_DEFAULT_OPTIONS,
				...options,
			});
			setCircleMarker(circleMarker);
			map.addLayer(circleMarker);

			const teardown = onInitialized(map, circleMarker);

			return () => {
				if (typeof teardown === 'function') {
					teardown();
				}

				circleMarker.remove();

				setCircleMarker(null);
			};
		}, [map, latLng, options, onInitialized]);

		return null;
	}
);

MapCircleMarker.propTypes = {
	latLng: PropTypes.arrayOf(PropTypes.number),
	options: PropTypes.shape({
		fillColor: PropTypes.string,
		fillOpacity: PropTypes.number,
		stroke: PropTypes.bool,
		radius: PropTypes.number,
	}),
	onInitialized: PropTypes.func,
};
